<template>
    <div class="container p-4 bg-light-blue">
        <div class="card bg-light-blue p-4">
            <div class="row">
                <div class="col-md-3">ภาพรวมครัวเรือนที่ประสบปัญหา ปี 2565</div>
                <div class="col-md-9">eef</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
}
</script>

<style scoped>
.bg-light-blue {
    background-color: #e0f7f7;
}
</style>
